/* eslint-disable eqeqeq */
import React, { useState } from "react";
import { handleForgotPassword } from "../../firebaseFunctions/forgotPassword/forgotPassword";
import { useAuth } from "../../context/AuthContext"

const ForgotPasswordModal = ({ isOpen, onClose, email }) => {
    const { user } = useAuth();
    const [userEmail, setUserEmail] = useState(email || "")

    const handleResetPassword = async (e) => {
      e.preventDefault()
      try {
        const sameEmail = checkIfEmailIsUsersEmail(userEmail)
        console.log(sameEmail)

        if(sameEmail) {

            const response = await handleForgotPassword(userEmail, user)

            if (response.success) {
                alert("Password reset email sent! Check your inbox.");
                setUserEmail("");
                onClose();
            } else {
                alert(response.message);
            }

        } else {
            alert("The email you entered does not match your current email.", e);
        }
      } catch (error) {
        console.error("Error sending password reset email:", error);
        alert("Failed to send password reset email.");
      }

    }

    const checkIfEmailIsUsersEmail = (email) => {
        const currentUserEmail = user.email
        if (email == currentUserEmail) {
            return true
        } else {
            return false
        }
    }

    const handleClose = () => {
        setUserEmail(""); // Reset the email field when closing the modal
        onClose(); // Call the parent onClose function
      };
  
    if (!isOpen) return null
  
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center">
  {/* Backdrop with blur and dark opacity */}
  <div className="absolute inset-0 bg-gray-900 opacity-50 backdrop-filter backdrop-blur-sm z-40"></div>

  {/* Modal content */}
  <div className="bg-white rounded-lg shadow-lg max-w-md w-full p-6 z-50">
    <h2 className="text-lg font-semibold text-center">Forgot Password</h2>
    <form onSubmit={handleResetPassword}>
      <p className="text-sm mb-2 text-center">Enter your email to receive a password reset link.</p>
      <input
        type="email"
        value={userEmail}
        onChange={(e) => setUserEmail(e.target.value)}
        placeholder="example@email.com"
        className="w-full p-2 border border-gray-300 rounded-lg mb-4 text-sm"
        required
      />
      <div className="flex justify-end space-x-4 justify-center">
        <button
          type="button"
          onClick={handleClose}
          className="bg-white text-[#101828] border border-gray-300 rounded-lg px-4 py-3 shadow-sm hover:bg-gray-50 text-base flex items-center justify-center"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] rounded-lg bg-[#344054] flex items-center justify-center py-3 px-4 text-base text-[#fcfcfd]"
        >
          Reset Password
        </button>
      </div>
    </form>
  </div>
</div>
    )
  }

  export default ForgotPasswordModal